import { useEffect, useRef, useState } from "react"

type RevealOptions = {
    threshold?: number
    rootMargin?: string
}

export function useRevealOnScroll<T extends HTMLElement = HTMLDivElement>(
    options?: RevealOptions
) {
    const ref = useRef<T>(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (typeof IntersectionObserver === "undefined") {
            setIsVisible(true)
            return
        }

        const target = ref.current
        if (!target) return

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true)
                    observer.unobserve(entry.target)
                }
            },
            {
                // 少しでも交差したら発火（要素が15%見えるまで待たない）
                threshold: options?.threshold ?? 0,
                // ビューポート下端をさらに15%広げ、要素が入る手前で早めに発火させる
                rootMargin: options?.rootMargin ?? "0px 0px 15% 0px",
            }
        )

        observer.observe(target)

        return () => {
            observer.disconnect()
        }
    }, [options?.threshold, options?.rootMargin])

    return { ref, isVisible }
}
